var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgShareCopy(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2 0A1.8 1.8 0 0118 1.8v9.919a3.6 3.6 0 01-.964 2.451l-3.051 3.282a3.6 3.6 0 01-2.636 1.148H1.8A1.8 1.8 0 010 16.8v-15A1.8 1.8 0 011.8 0zm0 1.2H1.8a.6.6 0 00-.6.6v15a.6.6 0 00.6.6h9.549c.06 0 .118-.002.177-.007h-.18v-4.2a1.8 1.8 0 011.695-1.797l.105-.003 3.654-.001V1.8a.6.6 0 00-.503-.592L16.2 1.2zm.435 11.393h-3.489a.6.6 0 00-.596.53l-.004.07.001 3.886a2.4 2.4 0 00.56-.445l3.05-3.28a2.4 2.4 0 00.478-.76z",
    transform: "translate(4.8 4.2)",
    fill: `url(#${_id})`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.2h12a1.8 1.8 0 011.797 1.694L16.8 3v1.22h-1.2V3a.6.6 0 00-.53-.596L15 2.4H3a.6.6 0 00-.596.53L2.4 3v12.893a.6.6 0 00.53.596l.07.004h1.8v1.2H3a1.8 1.8 0 01-1.797-1.694l-.003-.106V3a1.8 1.8 0 011.694-1.797L3 1.2z",
    fill: `url(#${_id2})`
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: ".019%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.065%",
    y1: "84.72%",
    x2: "77.584%",
    y2: "0%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  })))));
}
export default SvgShareCopy;